import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

// Custom icon for new POI marker
const newPOIIcon = new L.Icon({
  iconUrl: 'data:image/svg+xml;base64,' + btoa(`
    <svg width="25" height="41" viewBox="0 0 25 41" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 0C5.596 0 0 5.596 0 12.5c0 6.904 12.5 28.5 12.5 28.5s12.5-21.596 12.5-28.5C25 5.596 19.404 0 12.5 0z" fill="#10b981" stroke="#065f46" stroke-width="1"/>
      <circle cx="12.5" cy="12.5" r="7" fill="#ffffff"/>
      <path d="M12.5 6v13M6 12.5h13" stroke="#10b981" stroke-width="3" stroke-linecap="round"/>
    </svg>
  `),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  shadowSize: [41, 41],
  shadowAnchor: [12, 41]
});

interface NewPOIMarkerProps {
  position: [number, number];
  onAddPOI: () => void;
  onCancel: () => void;
}

const NewPOIMarker: React.FC<NewPOIMarkerProps> = ({ position, onAddPOI, onCancel }) => {
  return (
    <Marker position={position} icon={newPOIIcon}>
      <Popup closeButton={false} autoClose={false} autoPan={false}>
        <div className="text-center min-w-[200px]">
          <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Add New POI</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 dark:text-gray-500 mb-3">
            Do you want to create a new Point of Interest at this location?
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400 dark:text-gray-500 mb-4">
            {position[0].toFixed(6)}, {position[1].toFixed(6)}
          </p>
          <div className="flex space-x-2">
            <button
              onClick={onCancel}
              className="bg-gray-300 text-gray-700 dark:text-gray-300 px-3 py-1 rounded text-sm hover:bg-gray-400 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onAddPOI}
              className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700 transition-colors"
            >
              Add POI
            </button>
          </div>
        </div>
      </Popup>
    </Marker>
  );
};

export default NewPOIMarker;